export const LOGO_SIZE = {
  width: 100,
  height: 36,
};
